import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "px-2" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" }
const _hoisted_6 = { class: "text-xs text-gray-500 font-medium" }
const _hoisted_7 = { class: "flex items-center justify-center mt-10" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 動画が見つかりませんでした。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_list_tag_checkbox = _resolveComponent("video-list-tag-checkbox")!
  const _component_video_list_date_range_picker = _resolveComponent("video-list-date-range-picker")!
  const _component_video_list_sort_switch = _resolveComponent("video-list-sort-switch")!
  const _component_video_thumbnail = _resolveComponent("video-thumbnail")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_pagination = _resolveComponent("base-pagination")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_video_list_tag_checkbox, { filterdVideos: _ctx.videos }, null, 8, ["filterdVideos"])
      ]),
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_video_list_date_range_picker, {
                  startDate: _ctx.startDate,
                  "onUpdate:startDate": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
                  endDate: _ctx.endDate,
                  "onUpdate:endDate": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDate) = $event))
                }, null, 8, ["startDate", "endDate"]),
                _createVNode(_component_video_list_sort_switch, {
                  class: "mt-5 ml-2",
                  sort: _ctx.sort,
                  "onUpdate:sort": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sort) = $event))
                }, null, 8, ["sort"])
              ])
            ]),
            (_ctx.toArray(_ctx.videos).length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedList, (video) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: video.id
                      }, [
                        _createVNode(_component_router_link, {
                          to: `/video/${video.id}`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_video_thumbnail, { video: video }, null, 8, ["video"]),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(video.video_watch_histories_count) + "回視聴・" + _toDisplayString(_ctx.dayjs(video.published_at).format('YYYY-MM-DD')), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_base_pagination, {
                      pagedList: _ctx.pagedList,
                      "onUpdate:pagedList": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pagedList) = $event)),
                      originalList: _ctx.videos,
                      pageSize: _ctx.pageSize
                    }, null, 8, ["pagedList", "originalList", "pageSize"])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_8
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}